import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material';
import { useId } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { Details } from '@repo/ui/Details';
import { NerdWalletBadge } from '../../../Icons/NerdWalletBadge';
import { StructuredContentRenderer } from '../..';

export type SMBWhyTrustNerdWalletProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export function SMBWhyTrustNerdWallet({ props }: SMBWhyTrustNerdWalletProps) {
  const idSuffix = useId();
  return (
    <Details
      variant="simple"
      detailsProps={{
        sx: {
          boxShadow: 0,
          border: `1px solid`,
          borderColor: 'neutral.lighter',
        },
      }}
      summaryComponentProps={{
        'aria-controls': `panel-content-smb-why-trust-nerdwallet-${idSuffix}`,
        sx: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingX: 2,
          paddingY: '12px',
          '&:hover': {
            outlineWidth: { xs: 0, md: '2px' },
            outlineStyle: 'solid',
            outlineColor: 'blues.light',
            backgroundColor: 'blues.lightest',
          },
        },
      }}
      SummaryComponent={
        <>
          <Box
            component="span"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
              margin: 1,
              paddingLeft: 1,
            }}
          >
            <NerdWalletBadge />
            <Typography variant="textBold">Why trust NerdWallet</Typography>
          </Box>
          <ExpandMoreIcon
            sx={{
              color: 'neutral.main',
              fontSize: '30px',
            }}
            className="expand-icon"
          />
        </>
      }
    >
      <Box id={`panel-content-smb-why-trust-nerdwallet-${idSuffix}`} sx={{ padding: 3 }}>
        <StructuredContentRenderer doc={props.children} />
      </Box>
    </Details>
  );
}
